import { bool, func, number, oneOfType, string } from 'prop-types'

import { FormConsumer } from 'views/components/atoms/Form'

const Textarea = props => {
  const { dataQa, disableAutoCompleteAndFriends, name, register, ...rest } =
    props

  let restProps = rest

  if (disableAutoCompleteAndFriends) {
    restProps = {
      ...restProps,
      autoCapitalize: 'off',
      autoComplete: 'off',
      autoCorrect: 'off',
      spellCheck: 'false',
    }
  }

  return (
    <FormConsumer>
      {formName => (
        <textarea
          data-qa-id={dataQa || `${formName}-${name}`}
          {...restProps}
          name={name}
          ref={register}
        />
      )}
    </FormConsumer>
  )
}

Textarea.propTypes = {
  dataQa: string,
  defaultValue: oneOfType([string, number]),
  disableAutoCompleteAndFriends: bool,
  disabled: bool,
  inputType: string,
  name: string.isRequired,
  register: func,
  required: bool,
  rows: number,
  value: oneOfType([string, number]),
}

Textarea.defaultProps = {
  disableAutoCompleteAndFriends: false,
  disabled: false,
  register: null,
  required: false,
  rows: 2,
}

export default Textarea
